import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

// Components
import Tippopover from "../UI/Tippopover";

const Input = ({
  label,
  id,
  name,
  placeholder,
  marginBottom,
  text,
  error,
  type = "text",
  placeholderRightContent,
  defaultValue,
  onChange,
  tip,
  rows = 5,
  ...rest
}) => {
  let classes = "";

  switch (marginBottom) {
    case "sm":
      classes = "mb-3";
      break;
    case "md":
      classes = "mb-4";
      break;
    default:
      break;
  }

  const { register } = useFormContext();
  const { onChange: onChangeFromHook, ref, ...moreFields } = register(id);
  const { t } = useTranslation();

  return (
    <div className={classes}>
      {label && (
        <>
          <div className="d-flex justify-content-between form-label-container">
            <label htmlFor={id} className="form-label">
              {label}
            </label>
            <div className="d-flex">
              {tip && (
                <div className="tooltip-container">
                  <button className="tooltip-button" type="button">
                    <i className="bi bi-info-circle" />
                  </button>
                  <Tippopover tip={tip} />
                </div>
              )}
              {placeholderRightContent}
            </div>
          </div>
        </>
      )}
      {text ? (
        <textarea
          className={`form-control ${error ? "is-invalid" : ""}`}
          id={id}
          name={name}
          placeholder={placeholder}
          rows={rows}
          autoComplete="off"
          defaultValue={defaultValue}
          {...rest}
          {...moreFields}
          ref={ref}
          onChange={(e) => {
            onChange && onChange(id, e.target.value);
            onChangeFromHook(e);
          }}
        ></textarea>
      ) : (
        <input
          type={type}
          className={`form-control ${error ? "is-invalid" : ""}`}
          id={id}
          name={name}
          placeholder={placeholder}
          autoComplete="off"
          defaultValue={defaultValue}
          {...rest}
          {...moreFields}
          ref={ref}
          onChange={(e) => {
            onChange && onChange(id, e.target.value);
            onChangeFromHook(e);
          }}
        />
      )}
      {error && <div className="invalid-feedback">{t(error)}</div>}
    </div>
  );
};

export default Input;
